import { render, staticRenderFns } from "./studentMealIndex.vue?vue&type=template&id=468ff1ec&"
import script from "./studentMealIndex.vue?vue&type=script&lang=js&"
export * from "./studentMealIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports